import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import { ArrowRightIcon } from '@adsk/alloy-react-icon';

type ActivityValueChangeProps = StylableComponent<HTMLDivElement> & {
  before?: ReactNode;
  after: ReactNode;
};

/**
 * ActivityValueChange component. Describes a single change between before and after values.
 */
const ActivityValueChange = React.forwardRef<
  HTMLDivElement,
  ActivityValueChangeProps
>(({ before, after, style, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          minHeight: 28,
          flexWrap: 'wrap',
          rowGap: 4,
        },
        style,
      ]}
      {...props}
    >
      {before && (
        <span
          css={[
            {
              marginRight: 7,
            },
          ]}
        >
          {before}
        </span>
      )}
      <div
        css={[
          {
            display: 'flex',
            alignItems: 'center',
          },
        ]}
      >
        {before && (
          <ArrowRightIcon
            style={{
              marginRight: 7,
              minWidth: 24,
              alignSelf: 'flex-start',
            }}
          />
        )}
        {after}
      </div>
    </div>
  );
});

ActivityValueChange.displayName = 'ActivityValueChange';

ActivityValueChange.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The value to render before change */
  before: PropTypes.node,
  /** The value to render after change */
  after: PropTypes.node.isRequired,
};

export default ActivityValueChange;
